import * as React from "react";
const SvgIcPinFilled = props => <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M13 10V4h.75V2.5h-7.5V4H7v6l-2.5 1.5V13h4.9v4.5h1.2V13h4.9v-1.5L13 10Z" /></svg>;
export default SvgIcPinFilled;